import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/mic.vue
var o = {
	name: "DtIconMic",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--mic"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Mic",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M4.586 1.086A2 2 0 0 1 8 2.5V6a2 2 0 1 1-4 0V2.5a2 2 0 0 1 .586-1.414ZM6 1.5a1 1 0 0 0-1 1V6a1 1 0 0 0 2 0V2.5a1 1 0 0 0-1-1Zm-3.5 3A.5.5 0 0 1 3 5v1a3 3 0 1 0 6 0V5a.5.5 0 0 1 1 0v1a4 4 0 0 1-3.5 3.969V11H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5V9.969A4 4 0 0 1 2 6V5a.5.5 0 0 1 .5-.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=mic.js.map